<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Blacklisted Applicant List">
      <template slot="actions">
        <vx-input-group class="mb-base">
          <vs-input class="w-full" placeholder="Enter Mobile No or Nid No" @keypress="onlyNumber"
                    v-model="searchParam"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" icon-pack="feather" icon="icon-search"
                         @click="serachInActiveApplicant(searchParam)">
              </vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <!--      <vs-table stripe
                      :sst="true"
                      @search="handleSearch"
                      @change-page="handleChangePage"
                      @sort="handleSort"
                      v-model="selected"
                      :total="meta.total"
                      pagination
                      :max-items="meta.per_page"
                      search
                      :data="applicantList">-->
      <vs-table stripe
                :sst="true"
                @change-page="handleChangePage"
                v-model="selected"
                :total="meta.total"
                pagination
                :max-items="meta.per_page"
                :data="applicantList">
        <!--<template slot="header">
          <h3>
            All Applicant
          </h3>
        </template>-->
        <template slot="thead">
          <vs-th sort-key="name">
            Name
          </vs-th>
          <vs-th sort-key="phone">
            Mobile
          </vs-th>
          <vs-th sort-key="nid">
            Nid no
          </vs-th>
          <vs-th sort-key="status">
            Status
          </vs-th>
          <vs-th sort-key="id">
            Action
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{data[indextr].name}}
            </vs-td>

            <vs-td :data="data[indextr].ekyc.phone">
              {{data[indextr].ekyc.phone}}
            </vs-td>

            <vs-td :data="data[indextr].ekyc.nid">
              {{data[indextr].ekyc.nid}}
            </vs-td>

            <vs-td :data="data[indextr].status">
              {{data[indextr].status==1?"Active":"Blacklisted"}}
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            class="clickable"/>
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2 clickable"/>-->
              <div class="demo-alignment">
                <feather-icon icon="EyeIcon" @click="applicantDetal(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
                <feather-icon color="danger" icon="UserPlusIcon" @click="unBlock(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        selectedPgae: 1,
        searchParam: '',
        selected: [],
      }
    },
    computed: {
      ...mapGetters(['applicantList', 'meta'])
    },
    mounted() {
      this.$store.dispatch('getApplicantList', 'applicants?status=false&page=' + this.selectedPgae);
      console.log(this.applicantList);
    },
    watch: {
      searchParam(value){
        if(value.length < 1){
          this.$store.dispatch('getApplicantList', 'applicants?status=false&page=' + this.selectedPgae);
        }
      }
    },
    methods: {
      handleChangePage(page) {
        this.selectedPgae = page;
        this.$store.dispatch('getApplicantList', 'applicants?status=false&page=' + this.selectedPgae);
      },
      applicantDetal(id) {
        this.$router.push('/applicant-details/' + id).catch(() => {
        })
      },
      onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      async unBlock(id) {
        const unBlockUser = {
          id: id,
          data: {
            status: 1
          }
        };
        console.log("ID", id);
        await this.$store.dispatch('updateApplicant', unBlockUser);
        await this.$store.dispatch('getApplicantList', 'applicants?status=false&page=' + this.selectedPgae);
      },
      serachInActiveApplicant(data){
        const param = `applicants?status=false&page=${this.selectedPgae}&search=${data}`;
        this.$store.dispatch('getApplicantList', param);
      }
    }
  }
</script>
